export default "__VITE_ASSET__afNV4YEV__"